import React from "react";
import styled from "styled-components";

// Styled Components
const BaggageFeesLinkStyled = styled.div`
  text-align: right;
  font-size: 14px;
`;

const BaggageFeesLink = ({ baggageFeeUrl }) =>
  baggageFeeUrl ? (
    <BaggageFeesLinkStyled>
      <a href={baggageFeeUrl} target="_blank">
        Baggage Fees
      </a>
    </BaggageFeesLinkStyled>
  ) : null;

export default BaggageFeesLink;



// WEBPACK FOOTER //
// ./src/components/BaggageFeesLink/index.js